// Offline feature flags (build-time). Default OFF everywhere. Production stays false
// until the owner completes the on-device persistence gate. Enable in a controlled
// preview via REACT_APP_OFFLINE_TEMPERATURES=true — never in production.
export const OFFLINE_TEMPERATURES_ENABLED =
  (process.env.REACT_APP_OFFLINE_TEMPERATURES || "").toLowerCase() === "true";
